import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './style/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Main from './pages/Main';

const App = () => {
    return(
        <BrowserRouter>
            <div className="app">
                <Routes>
                    <Route path='/:id' element={<Main/>}/>
                    <Route path='*' element={<Navigate to={`f${(+new Date()).toString(16)}`}/>}/>
                </Routes>
            </div>
        </BrowserRouter>
    )
}

export default App;